import { AxiosError } from 'axios';
import { PortalServiceChangeEventDto } from '@nimbus/portal-service';
import { axiosClient } from '@nx-frontend/shared/api';
import { generalEnv } from '@nx-frontend/shared/env';
import { PortalServiceChangeEventDto as PortalServiceChangeEventDtoManual } from '@nx-frontend/shared/types';
// TODO: clean everywhere
import { PortalIdentifierProps } from './portal-content-types';

export type PostPortalContentClientApiProps = PortalIdentifierProps & {
  changeEventsDto: PortalServiceChangeEventDto[] | PortalServiceChangeEventDtoManual[];
};

export class PostPortalContentError extends Error {
  public traceId?: number;

  constructor(message: string, traceId?: number) {
    super(message);
    this.traceId = traceId;
  }
}

export async function postPortalContentClientApi({
  changeEventsDto,
  ...restProps
}: PostPortalContentClientApiProps): Promise<void> {
  try {
    await axiosClient.post(`${generalEnv.nextApiPath}/contents`, changeEventsDto, {
      params: {
        ...restProps,
      },
    });
  } catch (err) {
    const axiosErr = err as AxiosError;
    const traceId = axiosErr.response?.headers['x-trace-id'];
    console.error(axiosErr);
    throw new PostPortalContentError('Internal error', traceId);
  }
}
